<template>
	<div class="small-12 large-4 newVersionModal flex vertical-align animated fadeInLeftBig" v-if="show_modal">
        <div class="small-2 flex justify-center">
            <i class="material-icons-outlined">info</i>
        </div>
        <div class="small-7">
            <h2 class="small-12">
                New Site Version Available
            </h2>
            <p class="small-12">
                Please click on the refresh button to upgrade.
            </p>
        </div>
        <div class="small-3 columns">
            <a class="borderRadius4 bgPrimaryBlue cWhite primaryButton flex justify-center" @click="wipeBrowserCache()">
                Refresh
            </a>
        </div>
    </div>
</template>

<script>

	// Import the events
	import { HasNewSiteVersion } from '@/events/app/HasNewSiteVersion'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'NewVersionModal',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			HasNewSiteVersion

		],

		/*
		**  Set the props
		*/

		props: {

			show_modal: {
                type: Boolean,
                default: false
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			latest_version_updated: {

				immediate: true, // Load on created
				handler(latest_version_updated) {

					if (latest_version_updated) this.refreshBrowser();

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			wipeBrowserCache: function() {

				/*  
				**  Update the user doc
				**  @event: Events/App/HasNewSiteVersion
				*/

				this.hasNewSiteVersionHandler();

            },

			refreshBrowser: function() {

				/*
                **  Hard reload the browser
                **  @service: @browser
                */
                
               	window.location.reload(true);

			}

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>